
import { CREATE_ADMIN_REGISTRATION_FAILURE, CREATE_ADMIN_REGISTRATION_REQUEST, CREATE_ADMIN_REGISTRATION_SUCCESS } from "./adminRegistrationTypes";

const initialStateForCreateAdmin = {
    loading: false,
    createAdmin: {},
    error: "",
  };
  
  const createAdminRegistrationReducer = (state = initialStateForCreateAdmin, action) => {
    switch (action.type) {
      case CREATE_ADMIN_REGISTRATION_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case CREATE_ADMIN_REGISTRATION_SUCCESS:
        return {
          loading: false,
          createAdmin: action.payload,
          error: "",
        };
      case CREATE_ADMIN_REGISTRATION_FAILURE:
        return {
          loading: false,
          createAdmin: {},
          error: action.payload,
        };
      default:
        return state;
    }
  };
   
  export {
    createAdminRegistrationReducer,
  };
  